import { Component, Input } from '@angular/core';
import { AbstractDataProvider } from 'src/app/AbstractDataProvider';
import { AnnouncementModel } from '../../../../shared/model/interfaces';
import { AuthServiceCustom } from '../../../../shared/service/auth.service';
import { DictionaryPipe } from '../../../../shared/pipes/dictionary.pipe';
import {getErrorMessageText} from '../../../helper';


@Component({
    selector: 'app-announcement-block',
    templateUrl: './announcement-block.component.html',
    styleUrls: ['./announcement-block.component.scss'],
    providers: [DictionaryPipe],
    standalone: false
})
export class AnnouncementBlockComponent {

  @Input() announcements: AnnouncementModel[] = [];

  display = false;
  alertMessage: string;

  downloadDocumentImagUrl: string = this.abstractDataProvider.baseUrl + 'api/File/FileDownloadFromDocumentImage?SeqNum=';

  constructor(private abstractDataProvider: AbstractDataProvider, private authService: AuthServiceCustom,
              private dictionaryPipe: DictionaryPipe) {
  }

  navigateToConfirmMsg() {
    this.authService.navigateToUrl('inbox', {type: 'confirms'});
  }

  Download(DocSeqNum: number, FileNum: number) {
    this.abstractDataProvider.getData('api/File/IsFileExist?SeqNum=' + DocSeqNum + '&forWhat=form')
      .subscribe(
        posts => {
          if (posts.Message) {
            this.display = true;
            this.alertMessage = posts.Message;
          } else if (posts.DocSeqNum) {
            // window.open(this.downloadDocumentImagUrl + posts.DocSeqNum + '&forWhat=form&CurrentUserNumber=' + posts.CurrentUserNumber + '&FileNum=' + FileNum, '_blank');
            const url = this.downloadDocumentImagUrl + posts.DocSeqNum + '&forWhat=form&CurrentUserNumber=' + posts.CurrentUserNumber + '&FileNum=' + FileNum;
            this.abstractDataProvider.downloadFile(url)
            .subscribe(_ => {}, error =>{
              this.display = true;
              this.alertMessage = getErrorMessageText(error);
            });
          } else {
            this.display = true;
            this.alertMessage = this.dictionaryPipe.transform('FILE_NOT_FOUND');
          }
        },
        error => {
          this.display = true;
          this.alertMessage =  getErrorMessageText(error);
        }
      );
  }

  onConfirm() {
    this.display = false;
  }


}
